module.exports = __webpack_public_path__ + "img/christmas-ribbon.e7f19b35.svg";